import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentUploadDirective } from './directives/document-upload.directive';

@Component({
  selector: 'app-document-upload',
  templateUrl: 'document-upload.component.html',
  styleUrls: ['document-upload.component.scss']
})
export class DocumentUploadComponent {
  @ViewChild("fileDropRef") fileDropEl: any //fileDropEl: ElementRef
  files: any[] = [];

  constructor() {
  }

  //on file drop handler
  onFileDropped(event: any) {
    const uploadFile: any = event[0];
    this.prepareFilesList(uploadFile);
  }
  //handle file from browsing
  fileBrowseHandler(event: any) {
    const uploadFileHandler: any = event.target.files[0];
    this.prepareFilesList(uploadFileHandler);
  }

  //  Delete file from files list @param index (File index)//
  deleteFile(index: number) {
    if (this.files[index].progress < 100) {
      return;
    }
    this.files.splice(index, 1);
  }

  // Simulate the upload process//
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */

  prepareFilesList(filesData: any) {
    //filesData.progress = 0;
    this.files.push(filesData);
    this.fileDropEl.nativeElement.value = "";
    //this.uploadFilesSimulator(0);
  }


  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  documentUpload = new FormGroup({
    uploadDocument: new FormControl(''),

  });
}